import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AvailabilitySchedule, Loader } from 'components';
import { availabilityScheduleActions } from 'store';
import { FindLoad } from 'utils';
import { serviceSingleStyles } from './styles';

const ACTION_TYPE = 'GET_AVAILABILITY_SCHEDULE_GLOBAL';
export const StaffAvailability = ({}) => {
    const classes = serviceSingleStyles();
    const dispatch = useDispatch();
    const params = useParams();
    const loader = FindLoad(ACTION_TYPE);

    useEffect(() => {
        dispatch(availabilityScheduleActions.getAvailabilitySchedule(params.id, 'Staff'));
    }, [dispatch]);

    if (loader?.length) return <Loader />;

    return (
        <div className={classes.staffGeneralWrapper}>
            <AvailabilitySchedule onModel={'Staff'} />
        </div>
    );
};
